// @core/api/endpoints/workflow/create_agent_tool.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AgentToolResponse,
  CreateAgentToolRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create agent tool
 * Creates a tool an agent node may be granted: an HTTP endpoint with a parameter schema and credential, a platform RPC, or knowledge retrieval.
 */
export async function CreateAgentTool(
  data: CreateAgentToolRequest,
  options?: RequestOptions
): Promise<AgentToolResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/agent-tools`;
  const requestOptions = options;
  return client.post<AgentToolResponse>(requestPath, data, requestOptions);
}
